import { Theme } from '@mui/material'

import useSharedStyles from '../shared.styles'

const useStyles = {
  ...useSharedStyles,
  intro: (isMobile: boolean) => ({
    ...useSharedStyles.intro(isMobile),
    maxWidth: isMobile ? '100%' : 358 + 64,
    marginX: 'auto',
  }),
  passcodeInput: (theme: Theme) => ({
    width: '41px',
    height: '48px',
    '& .MuiOutlinedInput-root': {
      height: '48px',
      borderRadius: '6px',
      backgroundColor: theme.palette.common.white,
    },
    '& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '0.755px solid rgba(0, 0, 0, 0.12)',
    },
    '& input': {
      textAlign: 'center',
    },
  }),
  fields: {
    flexWrap: 'nowrap',
    justifyContent: 'center',
    gap: 1,
    marginTop: 1,
  },
  actions: {
    ...useSharedStyles.submitContainer(),
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  continueButton: {
    minWidth: 88,
    minHeight: 40,
    borderRadius: 20,
    textTransform: 'none',
  },
  links: {
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 2,
  },
}

export default useStyles
